import { useEffect, useState } from 'react';
import { City } from '../../models';
import { CategoryData } from '../../models/action';
import { DEVICE_SCREENS_MAX_STRING } from '../../lib/consts';
import { Link } from '../Link';

export function CategoriesBlock({
  items,
  currentCity,
  ...restProps
}: {
  items: Array<CategoryData>;
  currentCity: City;
  className?: string;
}) {
  const [showAll, setShowAll] = useState<boolean>(true);
  useEffect(() => {
    setShowAll(!(items.length > 5));
  }, []);
  return (
    <div
      css={{
        marginBottom: '4rem',
        [DEVICE_SCREENS_MAX_STRING.md]: {
          marginBottom: '2rem',
        },
        ...restProps,
      }}
    >
      <h3
        css={{
          fontFamily: 'Montserrat',
          fontWeight: '700',
          fontSize: '2.43rem',
          marginBottom: 16,
          [DEVICE_SCREENS_MAX_STRING.sm]: {
            fontSize: '24px',
          },
        }}
      >
        Похожие категории
      </h3>
      {items.slice(0, showAll ? items.length : 5).map((el) => (
        <Link
          href={
            el.parent_slug
              ? `/${currentCity.url}/catalog/${el.parent_slug}/${el.slug}/`
              : `/${currentCity.url}/catalog/${el.slug}/`
          }
          key={el.id}
          css={{
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            borderWidth: '1px',
            borderStyle: 'solid',
            borderColor: '#7D7B7A',
            fontWeight: 400,
            fontSize: 14,
            padding: '3px 10px',
            borderRadius: '16px',
            color: '#000000',
            backgroundColor: 'white',
            marginBottom: 8,
            marginRight: 8,
          }}
        >
          {el.title}
        </Link>
      ))}
      {!showAll && (
        <button
          type='button'
          css={{
            cursor: 'pointer',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center',
            fontWeight: 400,
            fontSize: 14,
            padding: '3px 10px',
            borderRadius: '16px',
            color: 'white',
            backgroundColor: '#BFC1C3',
            marginBottom: 8,
            marginRight: 8,
          }}
          onClick={() => setShowAll(true)}
        >
          Показать больше
        </button>
      )}
    </div>
  );
}
